var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-navigation-drawer",
    {
      class: [
        "navigation-drawer",
        _vm.checkDrawerStatus,
        { "is-portal": _vm.isPortalUser },
      ],
      attrs: {
        app: "",
        clipped: "",
        dark: "",
        width: "250",
        "mini-variant-width": "53",
        height: _vm.drawerHeight,
        "mini-variant": _vm.mini,
        permanent: "",
        temporary: _vm.$vuetify.breakpoint.mdAndUp ? false : true,
      },
    },
    [
      _c(
        "v-list",
        { staticClass: "pa-0", attrs: { dense: "" } },
        [
          _vm._l(_vm.siteMenu, function (item, index) {
            return [
              item.children.length
                ? _c(
                    "v-list-group",
                    {
                      key: `${item.text}-${index}`,
                      staticClass: "submenu-list",
                      attrs: {
                        value: _vm.isPortalUser
                          ? true
                          : _vm.checkIfOpened(item.text),
                        "append-icon": _vm.iconRight,
                        "prepend-icon": !_vm.mini ? item.icon : "",
                        ripple: false,
                        disabled: _vm.mini,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function () {
                              return [
                                _c(
                                  "v-list-item",
                                  {
                                    staticClass: "header-submenu-text-item",
                                    attrs: { ripple: false },
                                  },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass: "list-item-title px-0",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.text.toUpperCase())
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _vm.mini
                        ? _c(
                            "v-popover",
                            {
                              class: _vm.checkIfHighlight(item),
                              attrs: {
                                slot: "prependIcon",
                                offset: "0",
                                placement: "right",
                                trigger: "hover",
                                popoverClass: "popover-custom-item",
                              },
                              slot: "prependIcon",
                            },
                            [
                              _c("v-icon", [_vm._v(_vm._s(item.icon))]),
                              _c("template", { slot: "popover" }, [
                                _c(
                                  "ul",
                                  { staticClass: "popover popover-menu" },
                                  _vm._l(item.children, function (child, i) {
                                    return _c(
                                      "li",
                                      {
                                        key: i,
                                        class: _vm.checkPopoverItemClasses(
                                          !!child.children
                                        ),
                                      },
                                      [
                                        child.children.length
                                          ? _c(
                                              "v-list-group",
                                              {
                                                key: `${child.text}-${index}`,
                                                attrs: {
                                                  "prepend-icon": child.icon,
                                                  "append-icon": _vm.iconRight,
                                                  ripple: false,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              attrs: {
                                                                ripple: false,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    child.text.toUpperCase()
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              _vm._l(
                                                child.children,
                                                function (subchild, subIndex) {
                                                  return _c(
                                                    "v-list-item",
                                                    {
                                                      key: `${subchild.text}-${subIndex}`,
                                                      staticClass:
                                                        "subchild-item",
                                                      attrs: {
                                                        to: subchild.internalUrl
                                                          ? `/${subchild.url}`
                                                          : "",
                                                        target: subchild.target,
                                                        href: subchild.internalUrl
                                                          ? ""
                                                          : _vm.formatUrl(
                                                              subchild.url
                                                            ),
                                                        ripple: false,
                                                      },
                                                    },
                                                    [
                                                      subchild.icon
                                                        ? _c(
                                                            "v-list-item-action",
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  class:
                                                                    _vm.checkIfCircleIconClass(
                                                                      subchild.icon,
                                                                      true
                                                                    ),
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      subchild.icon
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "subchild-title",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  subchild.text.toUpperCase()
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                class: [
                                                  "popover-no-subchild-item",
                                                  { "first-item": i === 0 },
                                                ],
                                              },
                                              [
                                                child.internalUrl
                                                  ? _c(
                                                      "router-link",
                                                      {
                                                        class: [
                                                          "popover-item-text",
                                                          {
                                                            "first-item":
                                                              i === 0,
                                                          },
                                                        ],
                                                        attrs: {
                                                          to: `/${child.url}`,
                                                          target: child.target,
                                                        },
                                                      },
                                                      [
                                                        i === 0
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "popover-icon",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.icon
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "popover-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(child.text)
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "popover-item-text",
                                                        attrs: {
                                                          target: child.target,
                                                          href: _vm.formatUrl(
                                                            child.url
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(child.text)
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            ),
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                ),
                              ]),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._l(item.children, function (child, index) {
                        return [
                          child.children.length
                            ? _c(
                                "v-list-group",
                                {
                                  key: `${child.text}-${index}`,
                                  staticClass: "subchild-list",
                                  attrs: {
                                    "sub-group": "",
                                    ripple: false,
                                    disabled: _vm.mini,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-list-item",
                                              { attrs: { ripple: false } },
                                              [
                                                _c(
                                                  "v-list-item-content",
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(
                                                          child.text.toUpperCase()
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "prependIcon" },
                                    [
                                      _c("v-icon", [
                                        _vm._v(_vm._s(child.icon)),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "template",
                                    { slot: "appendIcon" },
                                    [
                                      _c("v-icon", [
                                        _vm._v(_vm._s(_vm.iconRight)),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    child.children,
                                    function (subchild, subindex) {
                                      return _c(
                                        "v-list-item",
                                        {
                                          key: `${subchild.text}-${index}`,
                                          staticClass: "subchild-item px-2",
                                          attrs: {
                                            to: subchild.internalUrl
                                              ? `/${subchild.url}`
                                              : "",
                                            href: subchild.internalUrl
                                              ? ""
                                              : _vm.formatUrl(subchild.url),
                                            target: subchild.target,
                                            ripple: false,
                                          },
                                        },
                                        [
                                          subchild.icon
                                            ? _c(
                                                "v-list-item-action",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      class:
                                                        _vm.checkIfCircleIconClass(
                                                          subchild.icon,
                                                          true
                                                        ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(subchild.icon)
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "v-list-item-content",
                                            { staticClass: "pa-1" },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  _vm._s(
                                                    subchild.text.toUpperCase()
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          !child.children.length && !_vm.mini
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "submenu-item",
                                  attrs: {
                                    to: child.internalUrl
                                      ? `/${child.url}`
                                      : "",
                                    href: child.internalUrl
                                      ? ""
                                      : _vm.formatUrl(child.url),
                                    target: child.target,
                                    ripple: false,
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "list-item-title" },
                                        [
                                          _vm._v(
                                            _vm._s(child.text.toUpperCase())
                                          ),
                                          _vm.renderOpenWindowIcon(item.url)
                                            ? _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "open-window-icon-submenu",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.iconOpenWindow)
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  )
                : _c(
                    "v-list-item",
                    {
                      key: `${item.text}-${index}`,
                      staticClass: "menu-item",
                      class: _vm.checkSpecialItemClasses(item.text),
                      attrs: {
                        to: item.internalUrl
                          ? _vm.getInternalUrl(item.url, item.internalUrl)
                          : "",
                        href: item.internalUrl ? "" : _vm.formatUrl(item.url),
                        target: item.target,
                        ripple: false,
                      },
                    },
                    [
                      !_vm.mini
                        ? [
                            _c(
                              "v-list-item-action",
                              [
                                _c("v-icon", { staticClass: "drawer-icon" }, [
                                  _vm._v(_vm._s(item.icon)),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [
                                _c(
                                  "v-list-item-title",
                                  { staticClass: "list-item-title" },
                                  [
                                    _vm._v(_vm._s(item.text.toUpperCase())),
                                    _vm.renderOpenWindowIcon(item.url)
                                      ? _c(
                                          "v-icon",
                                          { staticClass: "open-window-icon" },
                                          [_vm._v(_vm._s(_vm.iconOpenWindow))]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c(
                              "v-popover",
                              {
                                attrs: {
                                  offset: "0",
                                  placement: "right",
                                  trigger: "hover",
                                  popoverClass: [
                                    item.text,
                                    { "is-portal": _vm.isPortalUser },
                                    "popover-custom-item",
                                  ],
                                },
                              },
                              [
                                _c("v-icon", [_vm._v(_vm._s(item.icon))]),
                                _c(
                                  "template",
                                  { slot: "popover" },
                                  [
                                    item.internalUrl
                                      ? _c(
                                          "router-link",
                                          {
                                            class: [
                                              "popover",
                                              "popover-link",
                                              _vm.checkSpecialItemClasses(
                                                item.text
                                              ),
                                            ],
                                            attrs: {
                                              to: `/${item.url}`,
                                              target: item.target,
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { staticClass: "popover-icon" },
                                              [_vm._v(_vm._s(item.icon))]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "popover-text" },
                                              [_vm._v(_vm._s(item.text))]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "a",
                                          {
                                            staticClass: "popover popover-link",
                                            attrs: {
                                              href: _vm.formatUrl(item.url),
                                              target: item.target,
                                            },
                                          },
                                          [_vm._v(_vm._s(item.text))]
                                        ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                          ],
                    ],
                    2
                  ),
            ]
          }),
          _c(
            "div",
            { staticClass: "btn-container" },
            [
              _vm.showIAButton
                ? _c("LfLabelButtonComponent", {
                    class: ["ia-search-button", { mini: _vm.mini }],
                    attrs: {
                      text: _vm.$t("views.search_ia.title"),
                      action: _vm.goToIASearch,
                      prependIconSrc: _vm.iaIcon,
                      variant: _vm.LabelButtonVariant.OUTLINED,
                      mini: _vm.mini,
                      size: "md",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "toogle-menu-btn-container",
          class: { mini: _vm.mini },
          on: { click: _vm.toogleNavigationDrawer },
        },
        [
          _c("button", { staticClass: "toogle-menu-btn" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("navigation.drawer-menu-items.collapse"))),
            ]),
            _c("div", { staticClass: "arrows-container" }, [
              _c("span", { class: _vm.iconRight }),
              _c("span", { class: _vm.iconLeft }),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }